import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '@components/Modal/Modal';

import { IConfirmationModalProps } from './ConfirmationModal.interface';

import './styles.scss';

const ConfirmationModal: FC<IConfirmationModalProps> = ({
  open,
  isLoading,
  onConfirm,
  onClose,
  title,
  rightActionTitle,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      onClose={onClose}
      open={open}
      icon={<img className="confirmation-modal__icon" src="/images/img-paperairplane.svg" />}
      title={title}
      className="confirmation-modal"
      leftActionTitle={t('common.cancel')}
      onLeftAction={onClose}
      rightActionTitle={rightActionTitle}
      isRightActionLoading={isLoading}
      onRightAction={onConfirm}
    />
  );
};

export default ConfirmationModal;
